import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NotFound from '@/components/pages/errors/NotFound'

Vue.use(Router)
// Add a catch all for 404
routes.push({
  path: '*',
  component: NotFound
})

export default new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js